import type { LearningStatus, WorksheetTag } from './schemas'

/***************** 학습지 태그 *****************/
export const WORKSHEET_TAG_KO = {
  BASIC: '기본',
  PRACTICE: '연습문제',
  HOMEWORK: '숙제',
  DAILY_TEST: '일일TEST',
  WEEKLY_TEST: '주간TEST',
  CHAPTER_TEST: '단원TEST',
  ENTRANCE_TEST: '입학TEST',
  SCHOOL_PREPARE: '내신대비',
  PRACTICE_TEST: '모의고사',
  CSA_TEST: '수능대비',
  GENERAL_TEST: '총괄TEST',
  WEAK_CHAPTER: '단원별 취약',
  WEAK_DATE: '기간별 오답',
  WEAK_WORKSHEET: '학습지 오답',
  WEAK_WORKBOOK: '교재 오답',
  ETC: '기타',
  PRACTICE_TEST_PAIR: '모의고사 쌍둥이',
  ARITHMETIC: '연산',
  CONCEPT_CHIP: '유형별 학습',
  CONCEPT_CHIP_WEAK_PROBLEM: '유형별 오답',
  CUSTOM_PAPER: '기타자료 유사',
  SCHOOL_TEST_PAPER: '기출 유사',
  REVIEW: '복습',
  SCHOOL_PREPARE_ESSAY: '내신대비 서술형',
  WEAK_CONCEPT_CHIP: '취약유형',
  WEAK_CONCEPT_CHIP_BY_GROUP: '그룹취약유형',
  DAILY_WORKSHEET: '오늘의 학습',
  MY_DB_ORIGINAL: '원본',
  PRACTICE_TEST_SIMILAR: '모의고사 유사',
  CREVERSE_ENTRANCE: '크레버스 입학테스트',
  WEAK_ARITHMETIC: '연산 오답',
} as const satisfies Record<WorksheetTag, string>

/***************** 학습 상태 한글 표기 *****************/
// COMPLETE 와 EXPIRED 는 화면에서 같은 말이다 — EXPIRED 는 시험이 끝난 뒤의 제출 완료라 학생에게는 구분이 없다.
export const LEARNING_STATUS_KO = {
  INCOMPLETE: '학습가능',
  PROGRESS: '풀이 중',
  COMPLETE: '학습완료',
  EXPIRED: '학습완료',
} as const satisfies Record<LearningStatus, string>
